import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API from "../../../services/api";
import "./inventory.css";

const MONTHS = [
  { v:"", l:"All Months" },
  { v:"01",l:"January" },{ v:"02",l:"February" },{ v:"03",l:"March" },
  { v:"04",l:"April" },  { v:"05",l:"May" },     { v:"06",l:"June" },
  { v:"07",l:"July" },   { v:"08",l:"August" },  { v:"09",l:"September" },
  { v:"10",l:"October" },{ v:"11",l:"November" },{ v:"12",l:"December" },
];

export default function InventoryList() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");
  const [month,   setMonth]   = useState("");
  const [year,    setYear]    = useState(new Date().getFullYear());

  const loadItems = async () => {
    try {
      setLoading(true);
      const res = await API.get(
        `/school-admin/inventory/items/?search=${search}&month=${month}&year=${year}`,
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      setItems(res.data.items || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadItems(); }, [search, month, year]);

  const deleteItem = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    try {
      await API.delete(`/school-admin/inventory/items/delete/${id}/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      loadItems();
    } catch { alert("Error deleting item"); }
  };

  const years = [new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1];

  return (
    <div className="inv-page">

      {/* ══ HERO ══ */}
      <div className="inv-hero">
        <div className="inv-hero-left">
          <div className="inv-hero-icon">📦</div>
          <div>
            <h2 className="inv-hero-title">Inventory Items</h2>
            <p className="inv-hero-sub">{items.length} items in stock</p>
          </div>
        </div>
        <div className="inv-hero-right">
          <Link to="/school-admin/inventory/categories" className="inv-btn-secondary">🗂 Categories</Link>
          <Link to="/school-admin/inventory/add" className="inv-btn-add">+ Add Item</Link>
        </div>
      </div>

      {/* ══ FILTER ══ */}
      <div className="inv-filter">
        <span className="inv-filter-label">Filter</span>
        <input
          className="inv-search"
          placeholder="🔍  Search by name, vendor, category…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select value={month} onChange={e => setMonth(e.target.value)}>
          {MONTHS.map(m => <option key={m.v} value={m.v}>{m.l}</option>)}
        </select>
        <select value={year} onChange={e => setYear(e.target.value)}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      {/* ══ TABLE ══ */}
      <div className="inv-card">
        {loading ? (
          <div className="inv-empty">
            <div className="inv-empty-icon">⏳</div>
            <strong>Loading items…</strong>
          </div>
        ) : items.length === 0 ? (
          <div className="inv-empty">
            <div className="inv-empty-icon">📭</div>
            <strong>No items found</strong>
            <p>Try adjusting filters or add a new item</p>
          </div>
        ) : (
          <table className="inv-table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Category</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Vendor</th>
                <th>Purchase Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id}>
                  <td><span className="inv-item-name">{item.name}</span></td>
                  <td>
                    {item.category
                      ? <span className="inv-cat-badge">{item.category}</span>
                      : <span style={{ color:"#94a3b8" }}>—</span>
                    }
                  </td>
                  <td><span className="inv-qty-badge">{item.quantity}</span></td>
                  <td><span className="inv-price">₹ {Number(item.purchase_price || 0).toLocaleString()}</span></td>
                  <td>{item.vendor || "—"}</td>
                  <td>{item.purchase_date || "—"}</td>
                  <td>
                    <button
                      className="inv-btn-edit"
                      onClick={() => navigate(`/school-admin/inventory/edit/${item.id}`)}
                    >
                      ✏️ Edit
                    </button>
                    <button className="inv-btn-del" onClick={() => deleteItem(item.id)}>
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
}
